<template>
  <div>
    <MaterialInfoEditDescriptions
      class="mt-2"
      :data="materialInfo"
      :disabled="disabled"
      @editMaterial="editMaterial"
      @delMaterial="delMaterial"
    ></MaterialInfoEditDescriptions>

  </div>
</template>
<script>
import MaterialInfoEditDescriptions from '../material-info-edit-descriptions'

export default {
  props: {
    disabled: { type: Boolean, default: true },
    isFormal: { type: Boolean, default: false },
    amzSkuCode: { type: String, default: '' },
    materialInfo: { type: Object, default: () => {} },
  },
  mixins: [],
  components: {  MaterialInfoEditDescriptions },
  data() {
    return {
      labelStyle: { width: '100px', fontSize: '14px', color: '#6C6C6C' },
      valueStyle: { fontSize: '14px', color: '#101010' },
    }
  },
  computed: {
    amzSkuMaterialCode() {
      return this.materialInfo.amzSkuMaterialCode
    },
    disabledEdit() {
      return this.disabled || this.isFormal
    },
  },
  mounted() {},
  methods: {
    delMaterial() {
      this.$emit('delMaterial', this.materialInfo)
    },
    editMaterial() {
      this.$emit('editMaterial', this.materialInfo)
    },
    openArtWork() {
      this.$emit('openArtWork', this.materialInfo)
    },
    reloadArtwork() {
      this.$refs.artworkList.getData()
    },
  },
}
</script>
<style lang="scss" scoped>
.work_div {
  height: 154px;
  min-width: 60px;
  line-height: 154px;
  text-align: center;
  font-size: 14px;
  color: #6c6c6c;
}
</style>
